export const TABLEAU_ATTRIBUTES = {
  contentUrl: 'ATTR(ContentURL)',
};
